import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Column */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img
                src="https://public.readdy.ai/ai/img_res/bf8fb9d8-73a0-4b4a-a748-f2decd3e400d.png"
                alt="InfoDrop.in"
                className="h-10 w-10 object-contain"
              />
              <span className="text-2xl font-bold" style={{ fontFamily: 'Poppins, sans-serif' }}>
                InfoDrop.in
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Your trusted source for gaming giveaways, tech guides, and helpful information. Safe, informative, and always free.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-gray-600 hover:border-orange-500 hover:bg-orange-500 transition-all duration-300 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-gray-600 hover:border-orange-500 hover:bg-orange-500 transition-all duration-300 cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-gray-600 hover:border-orange-500 hover:bg-orange-500 transition-all duration-300 cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-gray-600 hover:border-orange-500 hover:bg-orange-500 transition-all duration-300 cursor-pointer"
                aria-label="YouTube"
              >
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 text-sm cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/free-fire-giveaway" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 text-sm cursor-pointer">
                  Free Fire Giveaway
                </Link>
              </li>
              <li>
                <Link to="/bgmi-giveaway" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 text-sm cursor-pointer">
                  BGMI Giveaway
                </Link>
              </li>
              <li>
                <Link to="/tech-blog" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 text-sm cursor-pointer">
                  Tech Blog
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 text-sm cursor-pointer">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Categories</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/free-fire-giveaway" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 text-sm cursor-pointer">
                  Gaming Giveaways
                </Link>
              </li>
              <li>
                <Link to="/tech-blog" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 text-sm cursor-pointer">
                  Tech Guides
                </Link>
              </li>
              <li>
                <Link to="/tech-blog" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 text-sm cursor-pointer">
                  How-To Tutorials
                </Link>
              </li>
              <li>
                <Link to="/tech-blog" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 text-sm cursor-pointer">
                  App Reviews
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 text-sm cursor-pointer">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 text-sm cursor-pointer">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-conditions" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 text-sm cursor-pointer">
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <Link to="/disclaimer" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 text-sm cursor-pointer">
                  Disclaimer
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 text-sm cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
            <div className="mt-6">
              <p className="text-gray-400 text-xs mb-2">Email us:</p>
              <a
                href="mailto:contact.infodrop.in@gmail.com"
                className="text-orange-500 hover:text-orange-400 text-sm transition-colors duration-300 cursor-pointer break-all"
              >
                contact.infodrop.in@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2026 InfoDrop.in - All Rights Reserved
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-orange-500 text-sm transition-colors duration-300 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
